import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
// import EnquiryList from './components/EnquiryList';
// import EnquiryDetails from './components/EnquiryDetails';
import request from '../../service';
import Exported from '../../service/endpoints';
import FeedbackList from './components/FeedbackList';
import ModalDropdown from '../../component/ModalDropdown';
import { FormProvider, useForm } from 'react-hook-form';
import Button from '../../component/Button';
import InputBox from '../../component/InputBox';
import moment from 'moment'
import { StatusCode, StatusColor } from '../../helpers';
import CloseIcon from '@mui/icons-material/Close';
import { Toast } from '../../service/toast';

const Feedback = () => {
    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
    } = formMethods;

    const NAME = 'Name'
    const STATUS = 'Status'
    const dropdownList = [
        { label: NAME, value: [NAME] },
        { label: STATUS, value: [STATUS] },
    ]
    const [page, setPage] = useState(1);
    const [productTableList, setProductTableList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const [viewFeedback, setViewFeedback] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [sortSelected, setSortSelected] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedInfo, setSelectedInfo] = useState([])
    const [isReply, setIsReply] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [replyAgain, setReplyAgain] = useState(false)
    const [replyValue, setReplyValue] = useState([])
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.search?.split('?id=')
            const params = pathName[pathName?.length - 1]
            if (params) {
                setViewFeedback(true)
            } else {
                setViewFeedback(false)
            }
        }
    }, [location])

    useEffect(() => {
        getProductList(true)
    }, [searchInput, sortConfig, page])

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const redirectTo = () => {
        navigate(`?type=create`)
    }

    const handleView = (id) => {
        setSelectedId(id)
        setIsModalOpen(true)
        setIsReply(false)
        setReplyAgain(false)
    }

    const closeModal = () => {

        setSelectedId(null)
        setIsModalOpen(false)
    }

    const openInput = () => {
        setIsReply(true)
    }

    const getProductList = async (loading) => {
        setisLoading(loading)

        let url = Exported.Endpoints.getFeedbackList;
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction

        }

        await request({
            url: url,
            method: Exported.APIMethods.GET,
            params: { ...paramsObj }
        }).then((res) => {
            console.log(res)
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta,
                }
                setProductTableList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: err?.response?.data?.message || 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }

    const onSubmit = async (data) => {

        let url = `${Exported.Endpoints.replyToFeedback}?feedback_id=${selectedId}`
        let paramsObj = {
            is_resolved: false,
            admin_reply: data.reply
        }

        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: { ...paramsObj },
        }).then(async (res) => {
            console.log(res)
            await getProductList(true)
            setReplyValue([res?.data?.data])
            setIsReply(false)
            setReplyAgain(true)
            setIsModalOpen(false)
            Toast({
                type: 'success',
                message: 'Reply send successfully!'
            })
        }).catch((err) => {
            console.log(err)
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })

    }

    const getSpecificFeedback = async (id) => {
        let url = `${Exported.Endpoints.feebackItem}?feedback_id=${id}`
        await request({
            url: url,
            method: Exported.APIMethods.GET
        }).then((res) => {
            console.log(res)
            setSelectedInfo([res?.data?.data])
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        if (selectedId && isModalOpen) {
            getSpecificFeedback(selectedId)
        }
    }, [selectedId, isModalOpen])

    return (
        <>
            {!viewFeedback &&
                // ?
                //     <EnquiryDetails /> :

                <div className={`${classes.manageUserWrapper}`}>
                    <div className={`w-[100%] flex items-center justify-between`}>
                        <div className={`layout-title`}>Product Feedback</div>
                        <div className='flex items-center'>
                            <SearchBox value={searchInput} onChange={handleChange} placeholder={'Find by name, enquiry id...'} />
                        </div>
                    </div>
                    <div>
                        <FeedbackList
                            searchInput={searchInput}
                            handleClick={handleView}
                            page={page}
                            setPage={setPage}
                            productTableList={productTableList}
                            setProductTableList={setProductTableList}
                            isLoading={isLoading}
                            setisLoading={setisLoading}
                            sortConfig={sortConfig}
                            setSortConfig={setSortConfig}
                            getProductList={getProductList}
                        />
                    </div>
                    {isModalOpen &&
                        selectedInfo.map((item, index) => (
                            <ModalDropdown isOpen={isModalOpen} closePopUp={closeModal} key={index}>
                                <div className={`${classes.mainDiv} ${item?.admin_reply || isReply ? `h-[470px]` : `h-[380px]`} w-[906px]`}>
                                    <div className={`${classes.header}`}>
                                        <div className={`${classes.subHeader}`}>
                                            <p>{item?.user?.name}</p>
                                        </div>
                                        <CloseIcon className='cursor-pointer' onClick={closeModal} />
                                    </div>
                                    <div>
                                        <p className={`${classes.text}`}>{item?.feedback_date}</p>
                                    </div>
                                    <div>
                                        <p className={`${classes.refNumber}`}>{item?.product?.reference_number}, {item?.product?.product_sub_category?.title}</p>
                                        <p className={`${classes.refNumber}`}>Quantity: {item?.qty_purchased}</p>
                                        <p className={`${classes.text}`}>{item?.comments}</p>
                                    </div>
                                    {item?.admin_reply && !isReply ?
                                        <div>
                                            <p className={`${classes.refNumber}`}>Your reply</p>
                                            <p className={`${classes.text}`}>{item?.admin_reply}</p>
                                            {/* <Button text={"Reply again?"} style={{ margin: '10px 0' }} smallBtn onClick={() => openInput()} /> */}
                                        </div> : !isReply &&
                                        <Button text={"Send your Reply"} style={{ margin: '10px 0' }} smallBtn onClick={() => openInput()} />
                                    }
                                    <>
                                        {isReply && (
                                            <div className='flex-col'>
                                                <FormProvider {...formMethods}>
                                                    <form onSubmit={handleSubmit(onSubmit)}>
                                                        <InputBox
                                                            className={`${classes.replyText} w-[100%]`}
                                                            name={"reply"}
                                                            type={"textarea"}
                                                            label="Enter your reply"
                                                            {...register("reply", {
                                                                required: true,
                                                            })}
                                                            error={errors.reason}
                                                            messages={{
                                                                required: "Reply is required",
                                                            }}
                                                        />
                                                        <div className='flex justify-end'>
                                                            <Button text={"Send"} style={{ width: "130px", margin: '30px 0' }} smallBtn />
                                                        </div>
                                                    </form>
                                                </FormProvider>
                                            </div>
                                        )}
                                    </>

                                    {
                                        item?.admin_comment.length > 0 && item?.admin_comment != 0 ? (
                                            <div className='mt-5'>
                                                <p className={`${classes.refNumber}`}>Internal Comment</p>
                                                <p className={`${classes.text}`}>{item?.admin_comment}</p>
                                            </div>) : null
                                    }
                                </div>
                            </ModalDropdown>
                        ))
                    }
                </div>
            }

        </>
    )
}

export default Feedback